export const PosterRoutes = [
  {
    path: '/poster-land',
    name: 'PosterLand',
    component: () =>
      import(
        '@/views/Poster/land' /* webpackChunkName: "he-bei-poster-deal" */
      ),
    meta: {
      title: '展业工具',
      notForce: true,
      needToken: false
    }
  },
  
  {
    path: '/poster-changepwd',
    name: 'Posterchangepwd',
    component: () =>
      import(
        '@/views/Poster/changepwd' /* webpackChunkName: "he-bei-poster-deal" */
      ),
    meta: {
      title: '修改密码',
      notForce: true,
      needToken: false
    }
  },
  {
    path: '/poster-deal',
    name: 'PosterDeal',
    component: () =>
      import(
        '@/views/Poster/PosterDeal' /* webpackChunkName: "he-bei-poster-deal" */
      ),
    meta: {
      title: '海报管理',
      notForce: true,
      needToken: false
    }
  },
  {
    path: '/performance-inquiry',
    name: 'PerformanceInquiry',
    component: () => import('@/views/Poster/PerformanceInquiry'),
    meta: {
      title: '业绩查询',
      needToken: false
    }
  },
  {
    path: '/poster-result',
    name: 'PosterResult',
    component: () =>
      import(
        '@/views/Poster/PosterResult' /* webpackChunkName: "he-bei-poster-result" */
      ),
    meta: {
      title: '海报结果',
      notForce: true,
      needToken: false
    }
  },
  {
    path: '/perfect-information',
    name: 'PerfectInformation',
    component: () => import('@/views/Poster/PerfectInformation'),
    meta: {
      title: '完善信息',
      needToken: false
    }
  },
]
